<template>
  <div>
    <b-button v-if="isAuth && user && user.following"
              :id="{'followingButtonHeader': isHeaderDetails}"
              :class="{'small': size === 'small'}"
              class="transparent w-active followed-btn"
              @click="unfollow">{{ $t('followButton.siguiendo') }}</b-button>
    <b-button v-else-if="isAuth && user && !user.following"
              :id="{'followButtonHeader': isHeaderDetails}"
              :class="{'small': size === 'small'}"
              class="transparent follow-btn"
              @click="follow">{{ $t('followButton.seguir') }}</b-button>
    <b-button v-else-if="!isAuth"
              :id="{'followButtonHeader': isHeaderDetails}"
              :class="{'small': size === 'small'}"
              class="transparent follow-btn"
              @click="openSingUp">{{ $t('followButton.seguir') }}</b-button>
  </div>
</template>

<script>

export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {}
    },
    elementId: {
      type: Number,
      default: undefined
    },
    isHeaderDetails: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    detail: {
      type: Boolean,
      default: false
    },
    origin: {
      type: String,
      default: ''
    }
  },
  computed: {
    isAuth() {
      return (
        this.$store.state.initial.detail.user_id ||
        this.$store.state.user.detail.id
      )
    }
  },
  methods: {
    async follow() {
      await this.$store.dispatch(`${this.type}/follow`, {
        id: this.elementId
      })
      this.user.following = true
      if (this.isHeaderDetails) {
        await this.$store.dispatch('user/increaseCountFollowers')
      }
      await this._getFollowers()
    },
    async unfollow() {
      await this.$store.dispatch(`${this.type}/unfollow`, {
        id: this.elementId
      })
      this.user.following = false
      await this._getFollowers()

      if (this.isHeaderDetails) {
        await this.$store.dispatch('user/decreaseCountFollowers')
      }
    },
    openSingUp() {
      if (this.origin !== '')
        this.$root.$emit('openSignup', `${this.type}-follow-events`)
      else this.$root.$emit('openSignup', `${this.type}-follow`)
    },
    async _getFollowers() {
      if (this.type === 'artist') {
        this.$store.dispatch('user/artistFollowers', {
          artists: this.$store.state.artist.detail.id,
          page_size: 20,
          count: true
        })
      } else if (this.type === 'venue') {
        this.$store.dispatch('user/venueFollowers', {
          venues: this.$store.state.venue.detail.id,
          page_size: 20,
          count: true
        })
      } else if (this.type === 'company') {
        this.$store.dispatch('user/companyFollowers', {
          companies: this.$store.state.company.detail.id,
          page_size: 20,
          count: true
        })
        if (this.detail) await this._getChatsByCompany()
      }
    },
    async _getChatsByCompany() {
      await this.$store.dispatch(
        'chat/getInitMessages',
        this.$store.state.company.detail.chat
      )
    }
  }
}
</script>
<style lang="scss">
@import './follow.sass';
</style>
